goog.provide("shadow.js.shim.module$src$svg$type$adset_channel$connected_tv_svg$default");
shadow.js.shim.module$src$svg$type$adset_channel$connected_tv_svg$default = shadow.js.shim.module$src$svg$type$adset_channel$connected_tv_svg.default;
